import BackgroundContainer from './BackgroundContainer';

export default BackgroundContainer;
